import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireAuth } from '@/lib/route-guards'
import { SidebarProvider, SidebarInset } from "@/components/ui/sidebar";
import { AppSidebar } from "@/components/app-sidebar";
import { Header } from "@/components/header";
import { LoadingProvider, useLoading } from "@/contexts/loading-context";
import { LoadingModal } from "@/components/ui/loading-modal";

function AuthenticatedLayout() {
  const { isLoading, loadingMessage } = useLoading();

  return (
    <>
      <SidebarProvider>
        <AppSidebar />
        <SidebarInset className="min-w-0 ">
          <Header />
          <div className="flex flex-1 flex-col gap-4 w-full">
            <Outlet />
          </div>
        </SidebarInset>
      </SidebarProvider>
      <LoadingModal isOpen={isLoading} message={loadingMessage} />
    </>
  );
}

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: requireAuth,
  component: () => (
    <LoadingProvider>
      <AuthenticatedLayout />
    </LoadingProvider>
  ),
})